type QueryType = "query" | "mutation";

export class FetchError extends Error {
  queryType: QueryType;
  recordType?: string;
  context: unknown;
  constructor(args: {
    message: string;
    queryType: QueryType;
    recordType?: string;
    context?: unknown;
  }) {
    super(args.message);
    this.name = "FetchError";
    this.queryType = args.queryType;
    this.recordType = args.recordType;
    this.context = args.context;
  }
}

export class ApiError extends Error {
  status: number;
  queryType: QueryType;
  recordType?: string;
  context: unknown;
  constructor(args: {
    message: string;
    queryType: QueryType;
    recordType?: string;
    status: number;
    context?: unknown;
  }) {
    super(args.message);
    this.name = "ApiError";
    this.status = args.status;
    this.queryType = args.queryType;
    this.recordType = args.recordType;
  }
}

export class NoAuthTokenError extends Error {
  context: unknown;
  constructor(args?: { context?: unknown }) {
    super("No auth token provided");
    this.name = "NoAuthTokenError";
    this.context = args?.context;
  }
}
